import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import WarningPopup from '@/components/WarningPopup';
import ToggleNoLabel from '@/components/ToggleNoLabel';
import { toggleUserApproved } from '../actions';

const UserApprovalCell = ({
  category,
  user,
  onToggleApproved,
  disabled,
  currentUserId,
}) => (
  <Table.Cell collapsing className="aridhia-user-approval-cell">
    <WarningPopup disabled={currentUserId !== user.uuid}>
      <ToggleNoLabel
        className="aridhia-user-approval-cell-toggle"
        checked={user.approved}
        label={user.name}
        onClick={() => onToggleApproved(category, user.code)}
        disabled={disabled}
      />
    </WarningPopup>
  </Table.Cell>
);

const mapStateToProps = ({
  auth: { currentUser, role: { permissions: { users: { approve } } } },
}, { user }) => ({
  disabled: (user.archived && !user.approved) || user.updateStatus === states.PENDING || !approve,
  currentUserId: currentUser.id,
});

const mapDispatchToProps = {
  onToggleApproved: toggleUserApproved,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserApprovalCell);
